import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  Box,
  Checkbox,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from '@mui/material';
import React, { PropsWithChildren } from 'react';

import { theme as evoachDefaultTheme } from '../../theme/theme';
import { EvoachButton } from '../Button';
import { BaseComponent } from '../Component';

export interface ObjectCardHeaderMenuComponent extends BaseComponent {
  type: 'objectCardHederMenu';
  props: ObjectCardHeaderMenuProps;
}

export interface ObjectCardHeaderMenuItemProps {
  text: string;
  disabled: boolean;
  onClick: Function;
}

export type ObjectCardHeaderMenuProps = PropsWithChildren<{
  id?: string;
  menuitems?: ObjectCardHeaderMenuItemProps[];
  selectable?: boolean;
  onSelect?: Function;
  editable?: boolean;
  onEdit?: Function;
  buttonTitle?: string;
  onButtonClick?: Function;
  defaultSelected?: boolean;
  /** has higher priority than menuitems */
  customMenu?: React.ReactNode;
  customMenuIcon?: React.ReactNode;
}>;

export const ObjectCardHeaderMenu: React.FC<ObjectCardHeaderMenuProps> = ({
  id,
  menuitems,
  selectable,
  onSelect,
  editable,
  onEdit,
  buttonTitle,
  onButtonClick,
  defaultSelected = false,
  customMenu,
  customMenuIcon,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Box minWidth="25px">
        {selectable && onSelect && (
          <Checkbox
            defaultChecked={defaultSelected}
            color="secondary"
            onChange={() => onSelect(id)}
            sx={{
              padding: 0,
              color: evoachDefaultTheme.palette.secondary.main,
            }}
          />
        )}
      </Box>
      <Box minWidth="1px">
        {buttonTitle && onButtonClick && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0px',
            }}
          >
            <EvoachButton
              id="basic-button"
              onClick={() =>
                onButtonClick ? onButtonClick(id) : console.log(id)
              }
              style={{ borderRadius: '5px', padding: '5px' }}
            >
              <Typography variant="body2">{buttonTitle}</Typography>
            </EvoachButton>
          </div>
        )}
      </Box>

      <Box minWidth="25px" alignContent="center">
        {editable && onEdit && (
          <IconButton
            style={{ borderRadius: '5px', padding: '2px' }}
            onClick={() => onEdit(id)}
          >
            <EditIcon color="secondary" />
          </IconButton>
        )}

        {customMenu && (
          <>
            <IconButton
              onClick={handleClick}
              style={{ borderRadius: '5px', padding: '2px' }}
            >
              {customMenuIcon ?? <MoreVertIcon color="secondary" />}
            </IconButton>
            <Menu
              id="custom-component-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <Box>{customMenu}</Box>
            </Menu>
          </>
        )}

        {menuitems && customMenu === undefined && (
          <>
            <IconButton
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
              style={{ borderRadius: '5px', padding: '2px' }}
            >
              <MoreVertIcon color="secondary" />
            </IconButton>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              {menuitems.map(
                (menuitem: ObjectCardHeaderMenuItemProps, index: number) => (
                  <MenuItem
                    key={'objectcardheadermenu' + index}
                    onClick={() => {
                      if (!menuitem.disabled && menuitem.onClick) {
                        menuitem.onClick(id, index);
                      }
                      handleClose();
                    }}
                    disabled={menuitem.disabled}
                  >
                    <Typography variant="body2" color="secondary">
                      {menuitem.text}
                    </Typography>
                  </MenuItem>
                )
              )}
            </Menu>
          </>
        )}
      </Box>
    </Stack>
  );
};
